"use client"

import { PanelLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelLeftIcon = component(Icon)({ as: PanelLeft })
